module.exports = __webpack_public_path__ + "img/australia-ischemic-heart-disease-female.a6e74fba.png";